<template>
  <router-view :key="$route.meta.routerKeySection" />
</template>

<script>
import * as Firebase from "firebase/app";
import AuthService from "@/services/Auth";

export default {
  name: "App",

  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleResize);
    });

    this.handleResize();

    const vm = this;

    Firebase.auth().onAuthStateChanged(user => {
      if (user) {
        const amplitude = vm.$amplitude.getInstance();
        amplitude.setUserId(user.uid);

        amplitude.logEvent("user_login", {
          user: user.uid,
          verified: user.emailVerified
        });

        Firebase.auth()
          .currentUser.getIdToken(true)
          .then(idToken => {
            AuthService.updateToken(idToken);

            vm.$store.dispatch("user/logIn", {
              id: user.uid,
              email: user.email
            });

            vm.$store.dispatch("user/getUser");
          })
          .catch(error => {
            // handle the error
            console.log(error);
          });
      } else {
        vm.$store.commit("reset");
        vm.$store.dispatch("user/logOut");
      }
    });
  },

  methods: {
    handleResize() {
      if (
        this.$router.currentRoute.matched.some(
          route => route.meta.hideNavOnMobile
        )
      ) {
        if (window.innerWidth < 1024) {
          this.$store.dispatch("app/setShowHeader", false);
        }
        if (window.innerWidth >= 1024) {
          this.$store.dispatch("app/setShowHeader", true);
        }
      }
    }
  },

  watch: {
    $route: {
      handler(to) {
        if (
          to.matched.some(route => route.meta.hideNavOnMobile) &&
          window.innerWidth < 1024
        ) {
          this.$store.dispatch("app/setShowHeader", false);
        } else {
          this.$store.dispatch("app/setShowHeader", true);
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
body {
  background-color: #09090d !important;
}

.v-application {
  [class*="text-"] {
    font-family: objektiv-mk2, sans-serif !important;
  }
  font-family: objektiv-mk2, sans-serif !important;
}
</style>
